/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import { RackAddSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import SelectInput from '../../Input/SelectInput'
import TextField from '../../Input/TextInput'

const racks = [
  { id: 'rack', name: 'Selective' },
  { id: 'shelving', name: 'Shelving' },
  { id: 'ground', name: 'Ground Floor' },
  { id: 'double', name: 'Double Deep' }
]

const slotBeams = [
  { id: '2', name: '2' },
  { id: '3', name: '3' },
  { id: '4', name: '4' }
]

function ModalAddRack(props) {
  const [areas, setAreas] = useState([])
  const { warehouseId } = props
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [typeValue, setTypeValue] = useState('')
  useEffect(() => {
    if (props.show && warehouseId?.warehouseId) {
      loadArea()
    }
  }, [props.show, warehouseId])

  const handleSubmit = async (values) => {
    try {
      setLoadingSubmit(true)
      const response = await api.post('/master/racks', {
        ...values
      })
      if (response.data.success) {
        props.onHide()
        props.refreshData()
        Common.showPopUpSuccessMessage(response.data.message)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmit(false)
    }
  }

  const loadArea = async () => {
    try {
      const res = await api.get(
        `/master/area/all?id=${warehouseId?.warehouseId}`
      )
      setAreas(res.data.data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  return (
    <Modal
      {...props}
      onHide={() => {
        props.onHide()
        setTypeValue('')
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Rack</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            warehouse_id: warehouseId?.id,
            rack_name: '',
            total_beam: '',
            total_level: '',
            total_slot: '',
            area_id: '',
            type: '',
            category_id: ''
          }}
          validationSchema={RackAddSchema}
          onSubmit={(values) => {
            handleSubmit(values)
          }}
        >
          {({
            handleBlur,
            handleSubmit,
            handleChange,
            values,
            errors,
            isValid,
            dirty,
            touched,
            setFieldValue
          }) => {
            return (
              <Form className="d-grid gap-2" onSubmit={handleSubmit}>
                <Row>
                  <Col md={12}>
                    <TextField
                      label="name"
                      name="rack_name"
                      value={values.rack_name}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      placeholder="Input rack name"
                      styles={{ height: '45px' }}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="total beam"
                      name="total_beam"
                      value={values.total_beam}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      placeholder="Input total beam"
                      type="number"
                      disabled={typeValue === 'ground'}
                      styles={{ height: '45px' }}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="total level"
                      name="total_level"
                      value={values.total_level}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      placeholder="Input total level"
                      type="number"
                      disabled={typeValue === 'ground'}
                      styles={{ height: '45px' }}
                    />
                  </Col>
                  <Col md={4}>
                    <SelectInput
                      label="slot/beam"
                      name="total_slot"
                      id="total_slot"
                      value={values.total_slot}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      options={
                        typeValue === 'ground'
                          ? [{ id: '1', name: '1' }]
                          : slotBeams
                      }
                      styles={{ height: '45px' }}
                      required={true}
                      disabled={typeValue === 'ground'}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      label="area"
                      name="area_id"
                      id="area_id"
                      value={values.area_id}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      options={areas}
                      styles={{ height: '45px' }}
                      required={true}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      label="type"
                      name="type"
                      id="type"
                      value={values.type}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      options={racks}
                      handleChange={(e) => {
                        const val = e.target.value
                        if (val === 'ground') {
                          setFieldValue('type', 'ground')
                          setFieldValue('total_beam', 1)
                          setFieldValue('total_level', 1)
                          setFieldValue('total_slot', 1)
                          setTypeValue('ground')
                        } else {
                          setFieldValue('type', val)
                          setFieldValue('total_beam', values.total_beam ?? '')
                          setFieldValue('total_level', values.total_level ?? '')
                          setFieldValue('total_slot', values.total_slot ?? '')
                          setTypeValue(val)
                        }
                      }}
                      styles={{ height: '45px' }}
                      required={true}
                    />
                  </Col>
                </Row>
                <Modal.Footer className="mt-3">
                  <CustomCloseButton onClick={props.onHide} />
                  <CustomButton
                    onClick={handleSubmit}
                    variant={
                      !isValid || !dirty || loadingSubmit
                        ? 'secondary'
                        : 'warning'
                    }
                    disabled={!isValid || !dirty || loadingSubmit}
                    text={!loadingSubmit ? 'Add' : 'Loading...'}
                    classNameValue={`text-white ${
                      !isValid || !dirty || loadingSubmit ? 'opacity-25' : ''
                    }`}
                  />
                </Modal.Footer>
              </Form>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default ModalAddRack
